export const useStyles = (theme) => ({
  root: {
    padding: 20,
  },
  buttonRoot: {
    display: "flex",
    justifyContent: "center",
    padding: 10,
    [theme.breakpoints.down(960)]: {
      flexDirection: "column",
    },
  },
  gridStyle: {
    cursor: "pointer",
  },
  inputRoot: {
    height: 70,
  },
  labelRoot: {
    fontSize: 18,
    fontWeight: "bolder",
    backgroundColor: "#fff",
    paddingRight: 5,
  },
  notchedOutline: {},
  labelFocused: { color: "black !important" },
  focused: {
    "& $notchedOutline": {
      borderColor: "black !important",
    },
  },
  paper: {
    width: "100%",
    height: "20vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#c9c7ba",
  },
  genrePaper: {
    width: "100%",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    height: "40vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
    transition: `background 2s ease-in-out`,
    "&:hover": {
      background: "100%",
    },
    [theme.breakpoints.down(960)]: {
      height: "20vh",
    },
  },
  buttonStyle: {
    background: "#0a1f3a !important",
    outlineColor: "#0a1f3a !important",
    color: "#ffffff",
    fontSize: 18,
    borderRadius: 20,
    marginRight: 15,
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#eee !important",
      borderColor: "#0a1f3a !important",
      color: "#181818",
    },
    [theme.breakpoints.down(960)]: {
      marginRight: 0,
      marginBottom: 15,
    },
  },
  labelStyle: {
    fontSize: 25,
    display: "flex",
    justifyContent: "center",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  paginationStyle: {
    padding: 10,
    display: "flex",
    justifyContent: "center",
  },
  nameInputStyle: {
    textAlign: "center",
    width: "49%",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
});
